import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../hooks/use-toast';
import { Shield, Lock, Mail } from 'lucide-react';
import Seo from '../components/Seo';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ email: '', password: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await login(formData);
      console.log('Login response:', response);
      
      if (response && response.user && response.user.role !== 'admin') {
        toast({ title: 'Access Denied', description: 'Admin credentials required', variant: 'destructive' });
        setLoading(false);
        return;
      }

      toast({ title: 'Success', description: 'Logged in successfully!' });
      setTimeout(() => {
        navigate('/admin/content');
      }, 500);
    } catch (error) {
      console.error('Login error:', error);
      toast({ title: 'Login Failed', description: error.response?.data?.detail || error.message || 'Invalid credentials', variant: 'destructive' });
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 flex items-center justify-center px-4">
      <Seo title="Admin Login | Ecoway Cabs" description="Ecoway Cabs admin panel login." path="/admin/login" noindex={true} />
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <Shield className="h-8 w-8 text-blue-600" />
          </div>
          <CardTitle className="text-2xl">Admin Login</CardTitle>
          <p className="text-gray-600 mt-2">Sign in to access the admin panel</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email"><Mail className="inline h-4 w-4 mr-1" />Email</Label>
              <Input id="email" type="email" placeholder="admin@ecowaycabs.com" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} required />
            </div>
            <div>
              <Label htmlFor="password"><Lock className="inline h-4 w-4 mr-1" />Password</Label>
              <Input id="password" type="password" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} required />
            </div>
            <Button type="submit" className="w-full" size="lg" disabled={loading}>
              {loading ? 'Signing In...' : 'Sign In as Admin'}
            </Button>
          </form>
          <div className="mt-6 pt-6 border-t text-center">
            <button type="button" onClick={() => navigate('/')} className="text-sm text-blue-600 hover:text-blue-700">← Back to Homepage</button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;